var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33329 13.5797H11.6666C12.125 13.5797 12.5 13.2047 12.5 12.7464V8.57969H13.825C14.5666 8.57969 14.9416 7.67969 14.4166 7.15469L10.5916 3.32969C10.2666 3.00469 9.74163 3.00469 9.41663 3.32969L5.59163 7.15469C5.06663 7.67969 5.43329 8.57969 6.17496 8.57969H7.49996V12.7464C7.49996 13.2047 7.87496 13.5797 8.33329 13.5797ZM4.99996 15.2464H15C15.4583 15.2464 15.8333 15.6214 15.8333 16.0797C15.8333 16.538 15.4583 16.913 15 16.913H4.99996C4.54163 16.913 4.16663 16.538 4.16663 16.0797C4.16663 15.6214 4.54163 15.2464 4.99996 15.2464Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.06dc611bedd59bc86d26fd3da0459031.svg";
export { ForwardRef as ReactComponent };